import { UntypedFormGroup, UntypedFormControl, UntypedFormArray, Validators } from '@angular/forms';

import { PcgTableColumn } from '../../../../table/interfaces/pcg-table-column.interface';

export class BA_FiscalYearVm {
	fiscalYearId: number;
	fiscalYearName?: string;
	startDate: Date;
	endDate: Date;
	isCurrent: boolean;
	isCurrentStr?: string;
	isActive: boolean;
	isActiveStr?: string;
	friendlyRecordId?: string;

	static get FormData() {
		return this.getFormData();
	}

	static getFormData(validators = {}) {
		return {
			'fiscalYearId': new UntypedFormControl(0, [...(validators['fiscalYearId'] ?? []), ...[Validators.required]]),
			'fiscalYearName': new UntypedFormControl(null, [...(validators['fiscalYearName'] ?? []), ...[]]),
			'startDate': new UntypedFormControl('', [...(validators['startDate'] ?? []), ...[Validators.required]]),
			'endDate': new UntypedFormControl('', [...(validators['endDate'] ?? []), ...[Validators.required]]),
			'isCurrent': new UntypedFormControl(false, [...(validators['isCurrent'] ?? []), ...[]]),
			'isCurrentStr': new UntypedFormControl(null, [...(validators['isCurrentStr'] ?? []), ...[]]),
			'isActive': new UntypedFormControl(false, [...(validators['isActive'] ?? []), ...[]]),
			'isActiveStr': new UntypedFormControl(null, [...(validators['isActiveStr'] ?? []), ...[]]),
			'friendlyRecordId': new UntypedFormControl(null, [...(validators['friendlyRecordId'] ?? []), ...[]])
		};
	}

	static get Form() {
		return new UntypedFormGroup(this.FormData);
	}

	static get ColumnDefs(): Map<string, PcgTableColumn> {
		return new Map([
			['fiscalYearName', {"orderId":0,"sortColumn":"endDate","searchColumn":"fiscalYearName","includeInExcel":true,"exportColumns":null,"displayName":"Fiscal Year","isVisible":true,"canSearch":true,"isNdc":false,"isNdc10":false,"isSum":false,"multiSearchCellClasses":null,"requiresFullAccess":false,"cellClass":null,"cellTransform":null,"cellNavigationColumn":null,"canSort":true,"isCurrency":false,"isPercent":false,"isEditableField":false,"headerTooltip":"","isPrint":true,"exportFormat":null}],
			['startDate', {"orderId":1,"sortColumn":"startDate","searchColumn":"startDate","includeInExcel":true,"exportColumns":null,"displayName":"Start Date","isVisible":true,"canSearch":true,"isNdc":false,"isNdc10":false,"isSum":false,"multiSearchCellClasses":null,"requiresFullAccess":false,"cellClass":"text-center","cellTransform":null,"cellNavigationColumn":null,"canSort":true,"isCurrency":false,"isPercent":false,"isEditableField":false,"headerTooltip":"","isPrint":true,"exportFormat":null}],
			['endDate', {"orderId":2,"sortColumn":"endDate","searchColumn":"endDate","includeInExcel":true,"exportColumns":null,"displayName":"End Date","isVisible":true,"canSearch":true,"isNdc":false,"isNdc10":false,"isSum":false,"multiSearchCellClasses":null,"requiresFullAccess":false,"cellClass":"text-center","cellTransform":null,"cellNavigationColumn":null,"canSort":true,"isCurrency":false,"isPercent":false,"isEditableField":false,"headerTooltip":"","isPrint":true,"exportFormat":null}],
			['isCurrentStr', {"orderId":3,"sortColumn":"isCurrentStr","searchColumn":"isCurrentStr","includeInExcel":true,"exportColumns":null,"displayName":"Is Current","isVisible":true,"canSearch":true,"isNdc":false,"isNdc10":false,"isSum":false,"multiSearchCellClasses":null,"requiresFullAccess":false,"cellClass":"text-center","cellTransform":null,"cellNavigationColumn":null,"canSort":true,"isCurrency":false,"isPercent":false,"isEditableField":false,"headerTooltip":"","isPrint":true,"exportFormat":null}],
			['isActiveStr', {"orderId":4,"sortColumn":"isActiveStr","searchColumn":"isActiveStr","includeInExcel":true,"exportColumns":null,"displayName":"Is Active","isVisible":true,"canSearch":true,"isNdc":false,"isNdc10":false,"isSum":false,"multiSearchCellClasses":null,"requiresFullAccess":false,"cellClass":"text-center","cellTransform":null,"cellNavigationColumn":null,"canSort":true,"isCurrency":false,"isPercent":false,"isEditableField":false,"headerTooltip":"","isPrint":true,"exportFormat":null}]
		]);
	}

	static GetModel(fg: UntypedFormGroup): BA_FiscalYearVmFromFg {
		return new BA_FiscalYearVmFromFg(fg);
	}
}

export class BA_FiscalYearVmFromFg {
	constructor(public fg: UntypedFormGroup) { }


	get fiscalYearId(): number {
		return this.fg.get('fiscalYearId').value;
	}
	set fiscalYearId(val) {
		this.fg.get('fiscalYearId').setValue(val);
	}

	get fiscalYearName(): string {
		return this.fg.get('fiscalYearName').value;
	}
	set fiscalYearName(val) {
		this.fg.get('fiscalYearName').setValue(val);
	}

	get startDate(): Date {
		return this.fg.get('startDate').value;
	}
	set startDate(val) {
		this.fg.get('startDate').setValue(val);
	}

	get endDate(): Date {
		return this.fg.get('endDate').value;
	}
	set endDate(val) {
		this.fg.get('endDate').setValue(val);
	}

	get isCurrent(): boolean {
		return this.fg.get('isCurrent').value;
	}
	set isCurrent(val) {
		this.fg.get('isCurrent').setValue(val);
	}

	get isCurrentStr(): string {
		return this.fg.get('isCurrentStr').value;
	}
	set isCurrentStr(val) {
		this.fg.get('isCurrentStr').setValue(val);
	}

	get isActive(): boolean {
		return this.fg.get('isActive').value;
	}
	set isActive(val) {
		this.fg.get('isActive').setValue(val);
	}

	get isActiveStr(): string {
		return this.fg.get('isActiveStr').value;
	}
	set isActiveStr(val) {
		this.fg.get('isActiveStr').setValue(val);
	}

	get friendlyRecordId(): string {
		return this.fg.get('friendlyRecordId').value;
	}
	set friendlyRecordId(val) {
		this.fg.get('friendlyRecordId').setValue(val);
	}
}
